<template>
  <div class="product-introduce flex-center">
      <div class="col-md-12 introduce-banner flex-center">
        <img src="@static/img/product_introduce/price.png"  alt="">
      </div>
      <div class="col-md-12 introduce-img flex-lr-center flex-justify-end ">
        <img @click="alertFn" src="@static/img/product_introduce/icon1.png"  alt="">
        <img @click="alertFn" src="@static/img/product_introduce/icon2.png"  alt="">
      </div>
  </div>
</template>

<script>


export default {
  name: 'ProductIntroduce',
  methods: {
    alertFn() {
      alert('Ứng dụng đang được phát triển, hãy chờ đợi!');
    },
  },
  data () {
    return {
      msg: 'productIntroduce'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-introduce{
}
.introduce-banner{
  background: url('~@static/img/product_introduce/banner.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  height: 924px;
  width: 100%;
}

.introduce-banner>img{
  max-width: 1260px;
  width: 100%;
  height: 100%;
}
.introduce-img{
  background: url('~@static/img/product_introduce/img.png') no-repeat;
  background-size: 100% 100%;
  background-position: center;
  height: 188px;
  width: 100%;
  max-width: 1200px;
  margin: 34px auto 120px auto;
  padding-right: 38px;
  
}
.introduce-img>img{
  width: 220px;
  height: 60px;
  margin-left: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductIntroduce.vue